import { useMemo } from 'react';
import { detectUserType, extractIncomeRange } from '../utils/intentParser';
import type { UserType } from '../types';

interface UseIntentAnalysisReturn {
  detectedUserType: UserType | null;
  detectedIncomeRange: string | null;
}

export default function useIntentAnalysis(text: string): UseIntentAnalysisReturn {
  const result = useMemo(() => {
    if (!text || text.length < 10) {
      return { detectedUserType: null, detectedIncomeRange: null };
    }

    return {
      detectedUserType: detectUserType(text),
      detectedIncomeRange: extractIncomeRange(text),
    };
  }, [text]);

  return result;
}
